import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import axios from 'axios';
export var initializeBadGatewayInterceptor = function initializeBadGatewayInterceptor(history, badGatewayUrl) {
  return axios.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    var _error$response;

    return ((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 502 ? history.push(badGatewayUrl) : Promise.reject(error);
  });
};